import Utils, {UNDEFINED_VALUE} from "platform/util/Utils";
import {Currency} from "platform/enum/Currency";
import {Locale} from "core/format/Locale";

export class NumberFormat {

    private constructor() {
    }

    public static formatNumber(value: number, fraction?: number): string {
        return this.format(value, fraction, fraction);
    }

    public static formatPercent(value: number): string {
        return this.format(value, 0, 2) + "%";
    }

    public static formatMoney(value: number, currency?: string): string {
        if (Utils.isNotNull(value)) {
            const sign: string = Currency.sign(currency);
            return `${Utils.isNotEmpty(sign) ? sign : ""} ${this.format(value, 0, 2)}`;
        }
        return UNDEFINED_VALUE;
    }

    public static toFixed(v: number, fraction?: number): number {
        return Utils.isNotNull(v) ? parseFloat(v.toFixed(Utils.isNotNull(fraction) ? fraction : 2)) : v;
    }

    private static fillDecimalPartZeros(decimalPart: string , minFraction: number): string {
        while (decimalPart.length < minFraction) {
            decimalPart += "0";
        }
        return decimalPart;
    }

    public static format(value: number, minFraction?: number, maxFraction?: number): string {
        if (Utils.isNotNull(value)) {
            const numbersConfig: {thousandDelimiter: string, decimalDelimiter: string} = Locale.config.formats.numbers;
            const negative: boolean = value < 0;
            const parts: string[] = Math.abs(value).toString().split(".");
            let result = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, numbersConfig.thousandDelimiter);
            let decimalPart: string = parts[1];
            if (decimalPart) {
                decimalPart = decimalPart.replace(/0+$/, "");
                if (maxFraction > 0 && maxFraction >= minFraction && decimalPart.length > maxFraction) {
                    decimalPart = decimalPart.substring(0, maxFraction);
                }
                const minF: number = minFraction > 0 ? minFraction : 2;
                if (decimalPart) {
                    decimalPart = this.fillDecimalPartZeros(decimalPart, minF);
                    result = result + numbersConfig.decimalDelimiter + decimalPart;
                }
            }
            if (parseFloat(result.replace(numbersConfig.decimalDelimiter, ".")) > 0) {
                result = (negative ? "-" : "") + result;
            }
            if (!decimalPart && minFraction) {
                decimalPart = this.fillDecimalPartZeros("", minFraction);
                result = result + numbersConfig.decimalDelimiter + decimalPart;
            }
            return result;
        }
        return UNDEFINED_VALUE;
    }

    public static parse(value: string, maxFraction?: number): number {
        if (Utils.isNotNull(value)) {
            const numbersConfig: {thousandDelimiter: string, decimalDelimiter: string} = Locale.config.formats.numbers;
            const parts: string[] = value.split(numbersConfig.decimalDelimiter);
            let result = parts[0].replace(numbersConfig.thousandDelimiter, "");
            let decimalPart: string = parts[1];
            if (Utils.isNotEmpty(decimalPart)) {
                if (maxFraction > 0) {
                    decimalPart = decimalPart.substring(0, maxFraction);
                }
                result = result + "." + decimalPart;
            }
            return parseFloat(result);
        }
        return null;
    }
}
